<div *ngIf="pricingFeeDiscountData$ | async as feeDiscountData">
  <div class="flex items-center justify-between gap-3 mb-4">
    <h3 class="flex-1 !mb-0">Base price</h3>
    <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.basePrice"></sbnb-save-indicator>
  </div>
  <p class="text__small">
    Editing your Airbnb base price will update all days that do not have a price set manually or by a dynamic pricing
    integration. As new calendar dates open up, they take your base price.
  </p>

  <div *ngFor="let base of basePrice" class="flex items-center gap-3 pr-4 mb-2">
    <span class="flex-1 text-sm">
      {{ base.label }}
      <span *ngIf="base.description" class="text-xs text-night-lighter">
        <br />
        {{ base.description }}
      </span>
    </span>

    <div class="flex flex-col gap-2 items-end">
      <div class="flex gap-3 items-center">
        <sbnb-icon-airbnb [size]="12"></sbnb-icon-airbnb>
        <mat-form-field class="input__mini nopadding !max-w-[120px]">
          <input
            matInput
            type="number"
            maxlength="6"
            autocomplete="off"
            placeholder="0"
            [(ngModel)]="feeDiscountData[base.key].value"
            (change)="savePriceChange(base.key, feeDiscountData[base.key])" />
          <span matSuffix>{{ currency }}</span>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
